export const COMPLIANCE_LABEL = {
  up_to_date: "Up to date",
  due: "Due soon",
  overdue: "Overdue",
  never_visited: "Never visited",
};

export function complianceClasses(status) {
  switch (status) {
    case "up_to_date":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "due":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "overdue":
      return "bg-red-50 text-red-700 border-red-200";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}

export function categoryClasses(category) {
  switch (category) {
    case "Commercial":
      return "bg-indigo-50 text-indigo-700 border-indigo-200";
    case "Residential":
      return "bg-amber-50 text-amber-700 border-amber-200";
    default:
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function monthLabel(period) {
  if (!period) return "—";
  const [y, m] = period.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric",
  });
}

export function fmtSize(bytes) {
  if (!bytes) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function fmtMoney(v) {
  if (v == null || v === "") return "—";
  return `₹ ${Number(v).toLocaleString("en-IN")}`;
}
